import serviceRebalanceUsina from "@/services/serviceRebalanceUsina";
import serviceRebalanceUsinaInstalacao from "@/services/serviceRebalanceUsinaInstalacao";
import { toast } from "react-toastify";
import { downloadFileFromBase64 } from "../../../utils/utils";
import { format } from "date-fns";

class Actions {
    serviceStart(ids, cicloFaturamento) {
        
        const ciclo = cicloFaturamento
        ? format(cicloFaturamento, "MM/yyyy")
        : format(new Date(), "MM/yyyy");
 
         const newValues = {
             usinasIds: ids,
             mes: ciclo.toString().substring(0, 2),
             ano: ciclo.toString().substring(3),
         };

        serviceRebalanceUsina.start(newValues).then((information) => {
            if (information) {
                toast.info("O Rebalance será iniciado para a(s) usina(s) selecionada(s), por favor aguarde.");
            }
        });
    }

    serviceProcess(ids, cicloFaturamento) {

        const ciclo = cicloFaturamento
        ? format(cicloFaturamento, "MM/yyyy")
        : format(new Date(), "MM/yyyy");

        const newValues = {
            usinasIds: ids,
            mes: ciclo.toString().substring(0, 2),
            ano: ciclo.toString().substring(3),
        };

        serviceRebalanceUsina.process(newValues).then((information) => {
            if (information) {
                toast.info("O Rebalance será processado para a(s) usina(s) selecionada(s), por favor aguarde.");
            }
        });
    }

    serviceDownload(ids, cicloFaturamento) {

        const ciclo = cicloFaturamento
        ? format(cicloFaturamento, "MM/yyyy")
        : format(new Date(), "MM/yyyy");

        const newValues = {
            usinasIds: ids,
            mes: ciclo.toString().substring(0, 2),
            ano: ciclo.toString().substring(3),
        };

        serviceRebalanceUsina.download(newValues).then((base64) => {
            if (base64 && base64.data) {
                downloadFileFromBase64(base64.data, "rebalance", "csv");
            }
        });
    }

    async serviceSankhya(ids, cicloFaturamento) {
        const ciclo = cicloFaturamento
        ? format(cicloFaturamento, "MM/yyyy")
        : format(new Date(), "MM/yyyy");

        const newValues = {
            usinasIds: ids,
            mes: ciclo.toString().substring(0, 2),
            ano: ciclo.toString().substring(3),
        };

        const res = await serviceRebalanceUsina.sankhya(newValues)
        if (res) {
            toast.info("A sincronização será processada para a(s) usina(s) selecionada(s), por favor aguarde.");
            return res
        }
        return res
       
    }

    async serviceDelete(id){
        const res = await serviceRebalanceUsinaInstalacao.delete(id)
        if(res){
            toast.success("Deletado com sucesso.");
            return true;
        }
        return false;
    }

    async serviceDeleteMany(ids, status){
        const newValues ={
            ids: ids.join(',')
        }
        const res = await serviceRebalanceUsinaInstalacao.deleteMany(newValues);
        if(res){
            toast.info("O Delete será processado para o(s) itens(s) selecionada(s), por favor aguarde.");
            return true;
        }
        return false;
    }

    async serviceApprove(ids) {       
        const newValues = {
            rebalanceUsinaIds: ids,            
        };

        const res = await serviceRebalanceUsina.approve(newValues);
            if (res) {
                toast.success("Rebalance aprovado com sucesso para a(s) usina(s) selecionada(s).");
                return true;
            }
            return false;
    }

    async serviceReopen(ids) {       
        const newValues = {
            rebalanceUsinaIds: ids,            
        };

        const res = await serviceRebalanceUsina.reopen(newValues)
            if (res) {
                toast.success("Rebalance reaberto com sucesso para a(s) usina(s) selecionada(s).");
                return true;
            }
            return false;
    }

    async serviceApproveConcessionaria(ids) {       
        const newValues = {
            rebalanceUsinaIds: ids,            
        };

        const res = await serviceRebalanceUsina.approveConcessionaria(newValues);
            if (res) {
                return res;
            }
            return false;        
    }

    async serviceSendConcessionaria(ids, cicloFaturamento){
        const ciclo = cicloFaturamento
        ? format(cicloFaturamento, "MM/yyyy")
        : format(new Date(), "MM/yyyy");

        const newValues = {
            usinasIds: ids,
            mes: ciclo.toString().substring(0, 2),
            ano: ciclo.toString().substring(3),
        };

        const res = await serviceRebalanceUsina.sendConcessionaria(newValues)
        if (res) {
            toast.info("Os arquivos serão gerados e enviados aos e-mails configurados, por favor aguarde.");        
            return res
        }
        return res
    }

}

export default new Actions();
